<template>
    <modal :name="'appChat'" :draggable="draggable" :resizable="true" :clickToClose="false" :scrollable="true" :height="'70%'" :minWidth="minWidth" :width="panelWidth" :reset="true">
        <slot></slot>
    </modal>

</template>

<script>
export default {
  name: 'ChatModal',
  props: ['panelWidth'],
  data () {
    return {
    }
  },
  computed: {
    draggable () {
      if (window.innerWidth > 768) return '.drag-handle'
      return false
    },
    minWidth () {
      if (window.outerWidth > 768) return 700
      return 300
    }
  },
  mounted () {
    this.$modal.show('appChat')
  }
}
</script>
